import { render } from "./PriceService.vue?vue&type=template&id=7325255d&scoped=true"
import script from "./PriceService.vue?vue&type=script&lang=js"
export * from "./PriceService.vue?vue&type=script&lang=js"

import "./PriceService.vue?vue&type=style&index=0&id=7325255d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7325255d"]])

export default __exports__